import Toast, { useToast } from "vue-toastification"

// Toast Notification Component Styles
import "@core/scss/vue/libs/toastification.scss"

/**
 * NOTE: If you are using other transition them make sure to import it in `src/@core/scss/vue/libs/notification.scss` from it's source
 */

// Vue 3: Export plugin with options for use in main.js
export const toastOptions = {
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: false,
  icon: false,
  timeout: 3000,
  transition: "Vue-Toastification__fade",
  // Share app context so global components (like feather-icon) are available in toasts
  shareAppContext: true,
}

// Vue 3: Custom plugin wrapper that adds $toast to globalProperties
// vue-toastification v2 doesn't automatically add $toast like v1 did
const ToastPlugin = {
  install(app, options) {
    // Merge shareAppContext into options if not already set
    const mergedOptions = {
      shareAppContext: true,
      ...options,
    }

    // First, install the original Toast plugin
    app.use(Toast, mergedOptions)

    // Then manually add $toast to globalProperties for Options API compatibility
    // We need to defer this because useToast() needs the plugin to be installed first
    const toast = useToast()
    app.config.globalProperties.$toast = toast
  },
}

export default ToastPlugin
